import React, { useEffect, useState } from 'react';
import { fetchWeightData } from '../services/api'; // Adjust API import if needed
// import FilterComponent from '../components/FilterComponent'; // Adjust the path as needed
import './PageLayout.css'; // Import the CSS file

function WeightPage() {
    const [materials, setMaterials] = useState([]);
    const [filters, setFilters] = useState({});
    const [categories, setCategories] = useState([]); // For dropdown options

    // const filterFields = [
    //     { name: 'MeasurementUnitRateId', label: 'ID' },
    //     { name: 'MeasurementUnitName', label: 'Name' },
    //     { name: 'Category', label: 'Category' },
    //     { name: 'QuantityTypeName', label: 'Quantity Type' }, // New filter field
    // ];

    const filteredMaterials = materials.filter((material) => {
        return (
            (filters.MeasurementUnitRateId === undefined || material.MeasurementUnitRateId?.toString().includes(filters.MeasurementUnitRateId)) &&
            (filters.MeasurementUnitName === undefined || material.MeasurementUnitName?.toLowerCase().includes(filters.MeasurementUnitName?.toLowerCase() || '')) &&
            (filters.Category === undefined || material.Category === filters.Category) && // Filter using exact match for dropdown
            (filters.QuantityTypeName === undefined || material.QuantityTypeName?.toLowerCase().includes(filters.QuantityTypeName?.toLowerCase() || '')) // New filter logic
        );
    });

    // Fetch supply rates on component load
    useEffect(() => {
        fetchWeightData()
            .then(response => {
                console.log("Fetched weight data:", response.data); // Debug log
                setMaterials(response.data); // Set data

                // Extract unique categories for the dropdown
                const uniqueCategories = Array.from(new Set(response.data.map(item => item.Category))).filter(Boolean);
                setCategories(uniqueCategories);
            })
            .catch(error => console.error('Error fetching supply rates:', error));
    }, []);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters({
            ...filters,
            [name]: value === 'All' ? undefined : value, // Reset filter if "All" is selected
        });
    };

    return (
        <div className="supply-rates-container">
            <div className="filter-section">
                <h3>Filters</h3>
                
                <div className="filter-group">
                    <label htmlFor="MeasurementUnitRateId">ID</label>
                    <input
                        type="text"
                        name="MeasurementUnitRateId"
                        value={filters.MeasurementUnitRateId || ''}
                        onChange={handleFilterChange}
                        placeholder="Filter by ID"
                    />
                </div>

                <div className="filter-group">
                    <label htmlFor="MeasurementUnitName">Name</label>
                    <input
                        type="text"
                        name="MeasurementUnitName"
                        value={filters.MeasurementUnitName || ''}
                        onChange={handleFilterChange}
                        placeholder="Filter by Name"
                    />
                </div>

                <div className="filter-group">
                    <label htmlFor="Category">Category</label>
                    <select
                        name="Category"
                        value={filters.Category || 'All'}
                        onChange={handleFilterChange}
                    >
                        <option value="All">All</option>
                        {categories.map((category, index) => (
                            <option key={index} value={category}>
                                {category}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="filter-group">
                    <label htmlFor="QuantityTypeName">Quantity Type</label>
                    <input
                        type="text"
                        name="QuantityTypeName"
                        value={filters.QuantityTypeName || ''}
                        onChange={handleFilterChange}
                        placeholder="Filter by Quantity Type"
                    />
                </div>
            </div>

            <div className="table-section">
                <h1>Weight Data</h1>
                {filteredMaterials.length === 0 ? (
                    <p>No weight data found or data is still loading...</p>
                ) : (
                    <table className="supply-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Measurement ID</th>
                                <th>Value</th>
                                <th>Category</th>
                                <th>Quantity Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredMaterials.map((rate, index) => (
                                <tr key={index}>
                                    <td>{rate.MeasurementUnitRateId}</td>
                                    <td>{rate.MeasurementUnitName}</td>
                                    <td>{rate.MeasurementId}</td>
                                    <td>{rate.Value}</td>
                                    <td>{rate.Category}</td>
                                    <td>{rate.QuantityTypeName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default WeightPage;
